import { render, staticRenderFns } from "./FormLookupBlock.vue?vue&type=template&id=60a13a9a"
import script from "./FormLookupBlock.vue?vue&type=script&lang=js"
export * from "./FormLookupBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports